import { useDispatch } from "react-redux";
import { Images } from "../../../../assets/images";
import { ProjectData } from "../../Project"
import "./ProjectCard.scss";
import { setSelectedProject } from "../../../../redux/slices/projectDetailsSlice";
import { Chip } from "@mui/material";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";

interface ProjectCardProps {
    project: ProjectData;
}

export default function ProjectCard({ project }: Readonly<ProjectCardProps>) {
    // Fallback image logic (replace with your actual placeholder if needed)
    const dispatch = useDispatch();
    const imageUrl = project.p_image_url || Images.Card;
    const handleClickProject = (project: ProjectData) => {
        console.log("Clicked:", project);

        dispatch(setSelectedProject(project))
    }
    return (
        <div className="project-card" onClick={() => handleClickProject(project)}>
            <img
                className={`project-card__image `}
                src={imageUrl}
                alt={project.p_name}
                loading="lazy"
            />
            <div className="project-card__content">
                <div className="project-card__title">{project.p_name}</div>
                <div className="project-card__desc" dangerouslySetInnerHTML={{ __html: project.p_description }} />
                <div className="project-card__footer">
                    <span>Updated {new Date(project.updated_at).toLocaleDateString()}</span>
                    <Chip className={`llm-initializing ${project.llm_intro_status === "inProgress" ? "add-padding" : ""}`} label={<div>{project.llm_intro_status} {project.llm_intro_status === "inProgress" && <LoadingSpinner />}</div>} />
                </div>
            </div>
        </div>
    );
}